/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaricoCreateDTO
 */
export interface CaricoCreateDTO {
    /**
     * 
     * @type {Date}
     * @memberof CaricoCreateDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof CaricoCreateDTO
     */
    note?: string | null;
}

/**
 * Check if a given object implements the CaricoCreateDTO interface.
 */
export function instanceOfCaricoCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CaricoCreateDTOFromJSON(json: any): CaricoCreateDTO {
    return CaricoCreateDTOFromJSONTyped(json, false);
}

export function CaricoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaricoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : (new Date(json['data'])),
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function CaricoCreateDTOToJSON(value?: CaricoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data.toISOString()),
        'note': value.note,
    };
}

